<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keep_alive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keep_alive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {},
};
</script>

<style>
input,
button,
textarea {
  border: none;
  outline: none;
}
#app {
}
.qr img {
  padding: 0 1rem 2rem 1rem;
  width: 3.56rem;
  height: 3.56rem;
}
.content {
  -webkit-overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/App.vue